import i18n from '@/lang';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "weui-loading_toast vux-loading",
    class: !_vm.text ? 'vux-loading-no-text' : ''
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _c('div', {
    staticClass: "weui-toast",
    style: {
      position: _vm.position
    }
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm.text ? _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || i18n.tc("382"))), _vm._t("default")], 2) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };